// The framing width the sign-in and sign-up pages give their form fields, and
// everything stacked above and below them.
export const authColumnWidth = { xs: 'min(83vw, 468px)', sm: '350px' };
